import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/product-list-assets/cameras/door-access/retrofit-reader.jpg";
import type { Product } from "../../types";
import { readersAndIntercom } from "../product-list-groups/readersAndIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "../properties";

export const retrofitReader: Product = {
  id: "retrofitReader",
  productTitle: "Retrofit Reader",
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: image,
    width: 255,
    height: 182,
  },
  productListGroup: readersAndIntercom,
  description: "retrofitReader.description",
  techspecsPath: [SiteId.TechSpecs, `/unifi/door-access/ua-retrofit-reader`],
  storePathParts: {
    category: "door-access-readers",
    productSlug: "ua-retrofit-reader",
    collectionSlug: "access-reader",
  },
  isNew: true,
  isComingSoon: true,
  comingSoonButtonText: "accessRetrofit.comingSoon",
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '117 x 45 x 13.3 mm\n(4.6 x 1.8 x 0.5")',
      },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "retrofitReader.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "retrofitReader.powerMethod",
      },
    },
  ],
};
